import React from 'react';
import NextLink from "next/link";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

import Container from "../components/Common/Container";
import RequestADemo from "../components/Common/RequestADemo";
import Clients from "../components/Common/Clients";
import PricingCards from "../components/Pricing/PricingCards";
import PricingCompareTable from "../components/Pricing/PricingCompareTable";
import MetaTags from "../components/Common/MetaTags";

const Pricing = () => {
  const theme = useTheme();
  const { t } = useTranslation("pricing");

  return (
    <>
      <MetaTags scope="pricing" />
      <Box bgcolor={theme.palette.alternate.main} position={"relative"}>
        <Container position="relative" zIndex={2}>
          <PricingCards />
        </Container>
        <Box
          component={"svg"}
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 1921 273"
          sx={{
            position: "absolute",
            width: "100%",
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 1,
            height: "75%",
          }}
        >
          <polygon
            fill={theme.palette.background.paper}
            points="0,273 1921,273 1921,0 "
          />
        </Box>
      </Box>
      <Container maxWidth={1100}>
        <PricingCompareTable category="usages" />
      </Container>

      <Box bgcolor={theme.palette.alternate.main}>
        <Container maxWidth={1100}>
          <PricingCompareTable category="basic_modules" />
        </Container>
      </Box>

      <Container maxWidth={1100}>
        <PricingCompareTable category="extra_features" />
      </Container>

      <Box bgcolor={theme.palette.alternate.main}>
        <Container maxWidth={1100}>
          <PricingCompareTable category="services" />

          <Box marginTop={5} align="right">
            <NextLink href="/our-expertise" passHref>
              <Button
                variant="outlined"
                color="primary"
                component="a"
                size="large"
                endIcon={
                  <svg
                    width={16}
                    height={16}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    />
                  </svg>
                }
              >
                {t("services.cta")}
              </Button>
            </NextLink>
          </Box>
        </Container>
      </Box>

      <Container>
        <Clients title={t("clients_banner_title")} />
      </Container>
      <RequestADemo />
    </>
  );
};

export default Pricing;

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "pricing"])),
    },
  };
}
